import React from 'react';

const Footer = ({ translations, language }) => {
  const t = translations[language];
  
  return (
    <footer className="footer">
      <div className="container">
        <p className="footer-tag">{t.footer.tagline}</p>
        <div className="footer-div"></div>
        <p className="footer-copy">© {t.footer.copyright}</p>
      </div>
    </footer>
  );
};

export default Footer;
